import React from 'react'
import withOpenState from 'shared/ui/withOpenState'
import { Button } from 'shared/ui'
import Deals from './Deals'
import Company from './Company'
import Contact from './Contact'
import Lists from './Lists'
import { Section } from './Section'

import CreateContactModal from './Modals/CreateContact'

class Card extends React.PureComponent {
  render() {
    const {
      contactObject,
      listsObject,
      dealsObject,
      companyObject,
      isMissing,
      settings,
      open,
      onOpen,
      onClose,
      showCompanySection,
      showListSection,
      showDealSection,
      ownersById,
    } = this.props
    if (!contactObject) return null
    const error = contactObject.error
    if (isMissing) {
      return (
        <Section>
          {open && <CreateContactModal open={open} onClose={onClose} />}
          <p>No contact found.</p>
          <Button basic primary onClick={onOpen}>
            + Create contact
          </Button>
        </Section>
      )
    }
    if (error) {
      let message = error.message
      if (error.code === 500) {
        // eslint-disable-next-line no-console
        console.error(error)
        message = 'Server error'
      }
      return <React.Fragment>{message}</React.Fragment>
    }
    const properties = contactObject.properties
    if (!properties) return null
    return (
      <React.Fragment>
        {open && (
          <CreateContactModal
            open={open}
            onClose={this.closeCreateContactModal}
          />
        )}
        <Contact
          contactObject={contactObject}
          settings={settings}
          ownersById={ownersById}
        />
        {showListSection && (
          <Lists listsObject={listsObject} settings={settings} />
        )}
        {showCompanySection && (
          <Company
            companyObject={companyObject}
            settings={settings}
            ownersById={ownersById}
          />
        )}
        {showDealSection && (
          <Deals
            dealsObject={dealsObject}
            settings={settings}
            ownersById={ownersById}
          />
        )}
      </React.Fragment>
    )
  }
}

export default withOpenState(Card)
